export const ADMIN_MIGRATION_DEFAULT_SPACE_LOGO_CONFIG_FF =
	'confluence.frontend.admin.migration.default-space-logo-config';
export const ADMIN_MIGRATION_LANGUAGE_INDEXING_FF =
	'confluence.frontend.admin.migrations.language-indexing';
export const ADMIN_MIGRATION_HEADER_AND_FOOTER_CONFIG_FF =
	'confluence.frontend.admin.migration.header-and-footer-config';
export const ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_FF =
	'confluence.frontend.admin.migration.templates-and-blueprints';
export const ADMIN_SPACE_REPORTS_FF = 'confluence.frontend.admin.spaces.report';
export const ADMIN_MIGRATION_CODE_MACRO_CONFIGURATION_FF =
	'confluence.frontend.admin.migration.configure-code-macro_vy8r6';
export const ADMIN_MIGRATION_COLOR_SCHEME_FF = 'confluence.frontend.admin.migration.color-scheme';
export const ADMIN_MIGRATION_SECURITY_CONFIGURATION_FF =
	'confluence.frontend.admin.migration.security-config_q2r2t';
export const ADMIN_MIGRATION_APPLICATION_NAVIGATOR_FF =
	'confluence.frontend.admin.migration.application-navigator';
export const ADMIN_MIGRATION_TRASHED_SPACES_FF =
	'confluence.frontend.admin.migration.trashed-spaces';
export const ADMIN_MIGRATION_IMPORT_SPACES_FF = 'confluence.frontend.admin.migration.import-spaces';
export const ADMIN_MIGRATION_JIRA_MACRO_REPAIR_FF =
	'confluence.frontend.admin.migration.jira-macro-repair';
export const ADMIN_MIGRATION_MACRO_USAGE_FF = 'confluence.frontend.admin.migration.macro-usage';
export const ADMIN_MIGRATION_THEMES_FF = 'confluence.frontend.admin.migrations.themes';
export const ADMIN_MIGRATION_PDF_EXPORT_FF = 'confluence.frontend.admin.migration.pdf-export';
export const ADMIN_MIGRATION_SPACE_SETTINGS_FF =
	'confluence.frontend.admin.migration.space-settings-migrations';
